import api from './api';

// Get count of unacknowledged missed calls (for badge)
export const getMissedCallsCount = async (): Promise<{ count: number }> => {
  const response = await api.get<{ count: number }>('/calls/missed/count');
  return response.data;
};

// Acknowledge missed calls (clears badge)
// Pass call_id to acknowledge a specific call, or omit to acknowledge all
export const acknowledgeMissedCalls = async (callId?: string): Promise<void> => {
  await api.post('/calls/missed/acknowledge', callId ? { call_id: callId } : {});
};
